// src/components/layout/Topbar.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSignOutAlt, FaUserShield } from 'react-icons/fa';

export default function Topbar() {
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('token');
    navigate('/');
  };

  return (
    <div style={styles.topbar}>
      <div>
        <span style={styles.kicker}>Operations Console</span>
        <h1 style={styles.title}>Admin Dashboard</h1>
      </div>

      <div
        style={styles.profile}
        onClick={() => setShowDropdown(!showDropdown)}
      >
        <div style={styles.avatar}>
          <FaUserShield size={16} />
        </div>
        {showDropdown && (
          <div style={styles.dropdown}>
            <div style={styles.dropdownItem} onClick={handleLogout}>
              <FaSignOutAlt size={14} />
              Logout
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  topbar: {
    height: 78,
    minHeight: 78,
    backgroundColor: '#FFFDF7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 32px',
    borderBottom: '1px solid #E6D8BE',
    position: 'fixed',
    top: 0,
    left: 260,
    right: 0,
    zIndex: 20,
  },
  kicker: {
    display: 'block',
    color: '#8C8170',
    fontSize: 12,
    fontWeight: 800,
    textTransform: 'uppercase',
    letterSpacing: 0.8,
    marginBottom: 4,
  },
  title: {
    fontSize: 22,
    fontWeight: 900,
    color: '#0F3D2E',
    margin: 0,
  },
  profile: {
    position: 'relative',
    cursor: 'pointer',
  },
  avatar: {
    width: 35,
    height: 35,
    borderRadius: 8,
    backgroundColor: '#0F3D2E',
    color: '#C9A14A',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
  },
  dropdown: {
    position: 'absolute',
    top: 50,
    right: 0,
    backgroundColor: '#fff',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    borderRadius: 8,
    overflow: 'hidden',
    zIndex: 10,
    border: '1px solid #E6D8BE',
  },
  dropdownItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '10px 20px',
    cursor: 'pointer',
    fontSize: 14,
    color: '#0F3D2E',
    fontWeight: 800,
  },
};
